import { isSupported } from 'firebase/messaging'
import { handleLink } from '$logic/router/url'
import { showNotificationDialog } from '$comp/modals/notification-dialog'
import { isAndroid, isAndroidApp } from '$func/environmentInfo'
import { dateWithOffset } from '$logic/client-device/time-offset.service'
import { areStartupDialogsDisabled } from '$logic/router/helper'
import { StartUpModalQueue } from '$func/startup-modal-handler'
import { isLoggedIn } from '$logic/auth'
import {
  getLastNotifPermissionRejectionTime,
  getNotificationPermissionState,
  removeLastNotifPermissionRejectionTime,
  requestNotificationPermission,
  setLastNotifPermissionRejectionTime,
  subscribeToNotificationPermissionChange,
} from '$setup/notification/permission'
import {
  initializeFirebaseMessaging,
  removeFCMServiceworkerRegistration,
} from '$setup/notification/firebase'

export const registerNotification = async (
  onRegisterNotificationDone?: () => unknown,
) => {
  try {
    const isMessagingSupported = await isSupported()
    if (!isMessagingSupported) {
      onRegisterNotificationDone?.()
      console.warn('firebase messaging not supported')
      return
    }

    if (!('Notification' in window)) {
      onRegisterNotificationDone?.()
      console.warn('This browser does not support notifications.')
      return
    }

    await requestNotificationPermission()
    await initializeFirebaseMessaging()
  } catch (err) {
    setLastNotifPermissionRejectionTime()
    console.error(err)
  } finally {
    onRegisterNotificationDone?.()
  }
}

export const checkLastRejectionAndShowNotificationPermissionDialog = () => {
  const lastRejectionTime = getLastNotifPermissionRejectionTime()
  const oneWeekInMilliSeconds = 3600 * 24 * 7 * 1000

  if (areStartupDialogsDisabled()) return

  if (
    !lastRejectionTime ||
    dateWithOffset() - lastRejectionTime > oneWeekInMilliSeconds
  ) {
    void showNotificationDialog()
  }
}

export const getUserPermissionAndRegisterNotificationInNonAndroidDevices =
  async () => {
    if (isAndroidApp || isAndroid) {
      // TODO: remove this line of code after a while
      removeFCMServiceworkerRegistration()
      StartUpModalQueue.openNextModal()
      return
    }

    if (import.meta.env.VITE_ENABLE_PUSH_NOTIFICATION === 'true') {
      subscribeToNotificationPermissionChange(() => {
        removeLastNotifPermissionRejectionTime()
      })

      try {
        const permission = await getNotificationPermissionState()

        if (permission === 'denied') {
          StartUpModalQueue.openNextModal()
          return
        }
        if (permission === 'granted') {
          // service worker and fcm token should be updated at every startup
          void initializeFirebaseMessaging()
          StartUpModalQueue.openNextModal()
          return
        }

        // permission state is prompt|default
        // NOTE: We should defer the addRouter function call until the router initialization is complete.
        if (isLoggedIn())
          setTimeout(
            checkLastRejectionAndShowNotificationPermissionDialog,
            2000,
          )
      } catch (err) {
        StartUpModalQueue.openNextModal()
        console.log(err)
      }
    }
  }

navigator.serviceWorker?.addEventListener?.('message', event => {
  if (event.data.type === 'NOTIFICATION_CLICK')
    if (event.data.url) void handleLink(event.data.url)
})
